import { useEffect, useState } from 'react'
import type { Ancora } from './animacoesBlocos'
import { itemDoCatalogo, type Movel, type MovelTipo } from './engine'

/**
 * Móveis do modo criativo como imagens do Blender (SPEC-20261010-2330): uma imagem por móvel,
 * cor e lado, nos visuais de blocos (pixel 2.0) e realista. Bichinhos têm 4 quadros.
 * x, y = onde a imagem começa em px do tabuleiro, a partir do canto do móvel; a imagem é 3x maior.
 */

export type ConjuntoDeMoveis = 'blocos' | 'realista'
export type Sprite = { x: number; y: number; w: number; h: number; arq: string; anc: Ancora[] }
type ItemSprites = { padrao: string | null; quadros: number; sprites: Record<string, Sprite> }
export type Manifesto = Record<ConjuntoDeMoveis, Record<string, ItemSprites>>

const VERSAO = 1
export const ESCALA_MOVEIS = 3
let pedido: Promise<Manifesto | null> | null = null
export function manifestoDosMoveis() {
  pedido ??= fetch(`/escritorio/moveis/manifesto.json?v=${VERSAO}`)
    .then((r) => (r.ok ? (r.json() as Promise<Manifesto>) : null))
    .catch(() => null)
  return pedido
}

export function useManifestoDosMoveis() {
  const [m, setM] = useState<Manifesto | null>(null)
  useEffect(() => {
    let vivo = true
    void manifestoDosMoveis().then((x) => vivo && setM(x))
    return () => {
      vivo = false
    }
  }, [])
  return m
}

export type SpriteDoMovel = { s: Sprite; quadros: number; src: (q: number) => string }

/** A imagem certa de um móvel posto (lado e cor), ou nada se ainda não foi feita. */
export function spriteDo(man: Manifesto | null, conj: ConjuntoDeMoveis, kind: MovelTipo, variant: 'n' | 's' = 'n', color: string | null = null): SpriteDoMovel | null {
  const it = man?.[conj]?.[kind]
  if (!it) return null
  const lado = itemDoCatalogo(kind).gira ? variant : 'n'
  const cor = color ?? it.padrao ?? ''
  const s = it.sprites[`${lado}|${cor}`] ?? it.sprites[`${lado}|${it.padrao ?? ''}`] ?? Object.values(it.sprites)[0]
  if (!s) return null
  return { s, quadros: it.quadros, src: (q) => `/escritorio/moveis/${conj}/${s.arq}-${q}.webp?v=${VERSAO}` }
}

export const spriteDoMovel = (man: Manifesto | null, conj: ConjuntoDeMoveis, m: Movel) => spriteDo(man, conj, m.kind, m.variant, m.color)
